// extracted by mini-css-extract-plugin
export default {"scrollIndicator":"ScrollIndicator_scrollIndicator__NOyMD"};